import { render, staticRenderFns } from "./logisticsManage.vue?vue&type=template&id=1d2c2248&scoped=true&"
import script from "./logisticsManage.vue?vue&type=script&lang=js&"
export * from "./logisticsManage.vue?vue&type=script&lang=js&"
import style0 from "./logisticsManage.vue?vue&type=style&index=0&id=1d2c2248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c2248",
  null
  
)

export default component.exports